/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Ledg API
 * API for managing financial activities and transactions
 * OpenAPI spec version: 2.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import type { ApiSettings, UpdateUserSettingsRequest } from "./client.schemas";

/**
 * @summary Retrieve settings for the authenticated user
 */
export const getSettings = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiSettings>> => {
  return axios.default.get(`/v2/settings`, options);
};

export const getGetSettingsQueryKey = () => {
  return [`/v2/settings`] as const;
};

export const getGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<string>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({
    signal,
  }) => getSettings({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettings>>
>;
export type GetSettingsQueryError = AxiosError<string>;

/**
 * @summary Retrieve settings for the authenticated user
 */
export const useGetSettings = <
  TData = Awaited<ReturnType<typeof getSettings>>,
  TError = AxiosError<string>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Update settings for the authenticated user
 */
export const updateSettings = (
  updateSettingsRequest: UpdateUserSettingsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiSettings>> => {
  return axios.default.put(`/v2/settings`, updateSettingsRequest, options);
};

export const getUpdateSettingsMutationOptions = <
  TError = AxiosError<string>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: UpdateUserSettingsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: UpdateUserSettingsRequest },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSettings>>,
    { data: UpdateUserSettingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateSettings(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSettings>>
>;
export type UpdateSettingsMutationBody = UpdateUserSettingsRequest;
export type UpdateSettingsMutationError = AxiosError<string>;

/**
 * @summary Update settings for the authenticated user
 */
export const useUpdateSettings = <
  TError = AxiosError<string>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSettings>>,
    TError,
    { data: UpdateUserSettingsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSettings>>,
  TError,
  { data: UpdateUserSettingsRequest },
  TContext
> => {
  const mutationOptions = getUpdateSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};
